import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8dd1501c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=8dd1501c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd1501c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CompilationHeaderImg: require('/home/bitrix/frontend/components/compilations/CompilationHeaderImg.vue').default,MtArrowLink: require('/home/bitrix/frontend/components/other/MtArrowLink.vue').default,Preloader: require('/home/bitrix/frontend/components/other/Preloader.vue').default,CompilationsList: require('/home/bitrix/frontend/components/compilations/CompilationsList.vue').default,NotFound: require('/home/bitrix/frontend/components/gallery/NotFound.vue').default,Pagination: require('/home/bitrix/frontend/components/other/Pagination.vue').default})
